export const getWebsiteLanguage = (state) => {
  const {
    appGlobal: {
      language: { language },
    },
  } = state;
  return language;
};
